import parse from "html-react-parser";
import * as React from "react";

export function parseContentAfterFieldSelection(optionToContentAfterText, currentValue) {
  if (optionToContentAfterText) {
    const content: string = optionToContentAfterText.get(currentValue?.toString() ?? "") ?? "";
    const parsedContent = parse(content);
    return typeof parsedContent === "string" || Array.isArray(parsedContent) ? (
      <>{parsedContent}</>
    ) : (
      parsedContent
    );
  }
  return;
}
